import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "components/common";

const TILES = [
  { title: "Add new partner",        description: "Register a new donator or distributor.", to: "/partners/new" },
  { title: "Add new log",            description: "Record a food pickup with weight and details.", to: "/logs/new" },
  { title: "Add new user",           description: "Create a contact user for a partner.", to: "/users/new" },
  { title: "Add new scheduled item", description: "Manually create a one-off pickup.", to: "/schedule-items/new" },
  { title: "Import schedule",        description: "Bulk-create appointments for a donator.", to: "/schedule-import" },
];

export default function AddNewPage() {
  const navigate = useNavigate();

  return (
    <div className="px-4 py-6 sm:px-8 sm:py-8">
      <PageHeader title="Add new" subtitle="Choose what to create" />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
        {TILES.map((tile) => (
          <button
            key={tile.to}
            onClick={() => navigate(tile.to)}
            className="card p-6 text-left hover:border-brand-200 hover:shadow-md transition-all group"
          >
            <h2 className="text-sm font-semibold text-gray-800 group-hover:text-brand-600 transition-colors mb-1">
              {tile.title}
            </h2>
            <p className="text-xs text-gray-500">{tile.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
